module.exports = __webpack_public_path__ + "img/8.5e612faf.jpg";